<script setup lang="ts">
import SvgAll from '~/assets/svg/all.svg'
import SvgHot from '~/assets/svg/hot.svg'

const selected = ref(0)

const categories = [{
  title: 'All',
  icon: SvgAll,
}, {
  title: 'Hot',
  icon: SvgHot,
}, {
  title: 'Rank#1',
}]

const ambassadors = [{
  name: 'Soong Hyu-en',
  token: 930000,
  avatar: '/images/pla-1.webp',
}, {
  name: 'Bae Soo Young',
  token: 9300000,
  avatar: '/images/pla-2.webp',
}, {
  name: 'Lee Min-soong',
  token: 930000,
  avatar: '/images/pla-3.webp',
}, {
  name: 'Hong Su Jin',
  token: 230000,
  avatar: '/images/pla-4.webp',
}, {
  name: 'Kwan Ji-anh',
  token: 232000500,
  avatar: '/images/pla-5.webp',
}, {
  name: 'Kim Hyuna',
  token: 14500000,
  avatar: '/images/pla-6.webp',
}, {
  name: 'Soong Hyu-en',
  token: 930000,
  avatar: '/images/pla-1.webp',
}, {
  name: 'Bae Soo Young',
  token: 9300000,
  avatar: '/images/pla-2.webp',
}, {
  name: 'Lee Min-soong',
  token: 930000,
  avatar: '/images/pla-3.webp',
}, {
  name: 'Hong Su Jin',
  token: 230000,
  avatar: '/images/pla-4.webp',
}, {
  name: 'Kwan Ji-anh',
  token: 232000500,
  avatar: '/images/pla-5.webp',
}, {
  name: 'Kim Hyuna',
  token: 14500000,
  avatar: '/images/pla-6.webp',
}, {
  name: 'Soong Hyu-en',
  token: 930000,
  avatar: '/images/pla-1.webp',
}, {
  name: 'Bae Soo Young',
  token: 9300000,
  avatar: '/images/pla-2.webp',
}, {
  name: 'Lee Min-soong',
  token: 930000,
  avatar: '/images/pla-3.webp',
}, {
  name: 'Hong Su Jin',
  token: 230000,
  avatar: '/images/pla-4.webp',
}, {
  name: 'Kwan Ji-anh',
  token: 232000500,
  avatar: '/images/pla-5.webp',
}, {
  name: 'Kim Hyuna',
  token: 14500000,
  avatar: '/images/pla-6.webp',
}, {
  name: 'Soong Hyu-en',
  token: 930000,
  avatar: '/images/pla-1.webp',
}, {
  name: 'Bae Soo Young',
  token: 9300000,
  avatar: '/images/pla-2.webp',
}, {
  name: 'Lee Min-soong',
  token: 930000,
  avatar: '/images/pla-3.webp',
}, {
  name: 'Hong Su Jin',
  token: 230000,
  avatar: '/images/pla-4.webp',
}, {
  name: 'Kwan Ji-anh',
  token: 232000500,
  avatar: '/images/pla-5.webp',
}, {
  name: 'Kim Hyuna',
  token: 14500000,
  avatar: '/images/pla-6.webp',
}, {
  name: 'Soong Hyu-en',
  token: 930000,
  avatar: '/images/pla-1.webp',
}, {
  name: 'Bae Soo Young',
  token: 9300000,
  avatar: '/images/pla-2.webp',
}, {
  name: 'Lee Min-soong',
  token: 930000,
  avatar: '/images/pla-3.webp',
}, {
  name: 'Hong Su Jin',
  token: 230000,
  avatar: '/images/pla-4.webp',
}, {
  name: 'Kwan Ji-anh',
  token: 232000500,
  avatar: '/images/pla-5.webp',
}, {
  name: 'Kim Hyuna',
  token: 14500000,
  avatar: '/images/pla-6.webp',
}]

const p = Math.floor(ambassadors.length / 3)
const arr1 = ambassadors.slice(0, p)
const arr2 = ambassadors.slice(p, p * 2)
const arr3 = ambassadors.slice(p * 2, p * 3)
const slices = [arr1, arr2, arr3]

const leaders = ambassadors.slice(4, 7)
</script>

<template>
  <div container w-full>
    <div row items-center>
      <h3 flex-grow text-24px font-bold>
        Ambassador Leaderboard
      </h3>
      <button class="b-1 b-#ce0000 rounded-full bg-transparent p-[8px_16px] text-14px">
        See All
      </button>
    </div>

    <LiveCategories v-model="selected" searchable :categories mt-27px />

    <div class="leader" mx-auto mt-23.6px h-192px row justify-center lg:mt-63px>
      <div v-for="leader, idx in leaders" :key="idx">
        <div mx-auto col items-center justify-center b-1.77px rounded-full b-solid size-83px class="b-#88888C">
          <img rounded-full object-cover size-69px :src="leader.avatar" :alt="leader.name">
        </div>

        <p mt-14px w-full flex-grow overflow-x-hidden text-ellipsis text-center text-14.16px font-bold>
          {{ leader.name }}
        </p>

        <p class="text-#88888C" mt-3.54px shrink-0 text-center text-10.62px>
          {{ $n(leader.token, { notation: 'compact' }) }} ROMA
        </p>
      </div>
    </div>

    <div grid grid-cols-1 mx-auto mt-20.4px gap-x-42px lg:grid-cols-3 lg:mt-42px lt-lg:max-w-400px lt-sm:px-8>
      <div v-for="slice, idx in slices" :key="idx">
        <div v-for="item, idx2 in slice" :key="idx2" mb-14px row items-center>
          <div w-21px shrink-0>
            {{ idx * p + idx2 + 4 }}
          </div>

          <img :src="item.avatar" ml-7px mr-10px shrink-0 rounded-full object-cover size-37px alt="">

          <span w-full flex-grow overflow-x-hidden text-ellipsis text-12.39px font-bold>
            {{ item.name }}
          </span>

          <span shrink-0 text-10.62px class="text-#88888C">
            {{ $n(item.token, { notation: 'compact' }) }} ROMA
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.mask {
  background: linear-gradient(
    180deg,
    rgba(31, 29, 43, 0) 18.01%,
    #1f1d2b 136.79%
  );
}

.leader {
  & > div {
    &:nth-child(1),
    &:nth-child(3) {
      place-self: end;
    }

    &:nth-child(3) {
      & > div {
        @apply b-#A06827;
      }
    }

    &:nth-child(2) {
      @apply mx-30.28px;

      & > div {
        @apply size-100.89px b-#FFB546;
        img {
          @apply size-86.73px;
        }
      }
    }
  }
}
</style>
